/*
ABOUT >>
THIS INPUT USED FOR CALLING API FOR SOFTWARE DROPDOWN 
FULLY DYNAMIC DATASOURCES BY USING API ROUTES 

ACTIVE >>
ITS IN RUNNING POSITION

UPDATES >>
IT WILL BE UPDATE FOR CALLING API FOR LIST DATASOURCE IF DataSourceType IS Route and give parameters with this api
*/
import http from '../../services/http-common';

class ApiService {
    getAllForList(type) {
    return http.get(`/dropdownApi/${type}`);
}
}

export default new ApiService();